import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ItemList from "../components/ItemList.jsx";

export default class PaperCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  getPaperNumber(url) {
    return url.substr('/papers/x'.length);
  }

  render() {
    const { abstract, authors, displaytypename, newthisweek, publisheddate, displaydate, title, type, url, certifiedrandom } = this.props;

    const ariaLabel = "Read the full article on " + title;

    const cardClass = classNames("digest-card", {
      "is-new": newthisweek
    });

    const listOptions = {
      "last_item_symbol": certifiedrandom ? "ⓡ" : "&",
      "item_concatenator": ","
    };

    return (
      <div className={cardClass}>
        { title && <div className="digest-card__title"><a ref={el => (this.itemWrapper = el)} href={ url }>{ title }</a></div>}
        { (displaydate || displaytypename) && <div className="digest-card__date">
            { displaydate && <span className="digest-card__label">
              { displaydate }
            </span> }
            { displaydate && displaytypename && <span> - </span> }
            { displaytypename && <span className="digest-card__label">
              { displaytypename }
            </span> }
            { url && <a href={ url } className="paper-card__paper_number">
              { this.getPaperNumber(url) }
            </a> }
          </div> }
        { authors && authors.length > 0 && <ItemList items={authors} options={listOptions} label="Author(s)" showMoreButton={authors.length > 9} /> }
        { abstract && <div className="digest-card__summary">{ abstract }...</div>}
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

PaperCard.propTypes= {
  abstract: string,
  authors: array,
  displaytypename: string,
  index: number,
  loading: bool,
  newthisweek: bool,
  publisheddate: string,
  displaydate: string,
  title: string,
  type: string,
  url: string,
  certifiedrandom: bool
};

PaperCard.defaultProps = {
  certifiedrandom: false
};
